import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MdKeyboardArrowRight } from 'react-icons/md';

const Breadcrumb = ({ items }) => {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter((x) => x);

    // If items prop is provided, render using items
    if (items && items.length > 0) {
        return (
            <div style={{
                padding: "0px 60px",
                marginTop: "100px",
                marginBottom: "-80px",
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                fontFamily: "'Work Sans', sans-serif",
                fontSize: "14px"
            }}>
                {items.map((item, index) => {
                    const isLast = index === items.length - 1 || !item.path;
                    return (
                        <React.Fragment key={index}>
                            {index > 0 && <MdKeyboardArrowRight style={{ color: "#666", margin: "0 5px", fontSize: "16px" }} />}
                            {isLast ? (
                                <span style={{ color: "#333", textTransform: "capitalize", fontWeight: "500" }}>
                                    {item.label}
                                </span>
                            ) : (
                                <Link to={item.path} style={{ color: "#00a2c7", textDecoration: "none", textTransform: "capitalize", fontWeight: "500" }}>
                                    {item.label}
                                </Link>
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        );
    }

    // Don't show breadcrumb on home page
    if (pathnames.length === 0) {
        return null;
    }

    return (
        <div style={{
            padding: "0px 60px",
            marginTop: "100px",
            marginBottom: "-80px",
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            fontFamily: "'Work Sans', sans-serif",
            fontSize: "14px"
        }}>
            <Link to="/" style={{ color: "#00a2c7", textDecoration: "none", fontWeight: "500" }}>
                Home
            </Link>
            {pathnames.map((name, index) => {
                const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
                const isLast = index === pathnames.length - 1;
                // Replace hyphens with spaces for better readability
                const displayName = name.replace(/-/g, ' ');

                return (
                    <React.Fragment key={name}>
                        <MdKeyboardArrowRight style={{ color: "#666", margin: "0 5px", fontSize: "16px" }} />
                        {isLast ? (
                            <span style={{ color: "#333", textTransform: "capitalize", fontWeight: "500" }}>
                                {displayName}
                            </span>
                        ) : (
                            <Link to={routeTo} style={{ color: "#00a2c7", textDecoration: "none", textTransform: "capitalize", fontWeight: "500" }}>
                                {displayName}
                            </Link>
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default Breadcrumb;
export { Breadcrumb as Breadcrumbs };
